import type {ChangeEvent} from 'react'
import {useDeferredValue, useState} from 'react'

import useEventCallback from '../../../../hooks/useEventCallback'

export const useSearchState = (initialValue?: string) => {
  const [search, setSearch] = useState(initialValue ?? '')
  const deferredSearch = useDeferredValue(search)

  const handleChangeSearch = useEventCallback((event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.currentTarget.value)
  })

  const handleClearSearch = useEventCallback(() => {
    setSearch('')
  })

  return {
    search,
    deferredSearch,
    handleChangeSearch,
    handleClearSearch,
  }
}
